export default __webpack_public_path__ + "static/media/33_TopRightSquares_Right.7c68e5cc.mp4";